exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".down-1 {\n    fill: #586671;\n  }", ""]);
